module.exports = __webpack_public_path__ + "media/images/flags/gb-wls-28763f267e98f51602109beaad91abe4.svg";